module.exports = __webpack_public_path__ + "static/how-to-read-the-air-fc42acc35bf6d91747d1ff5067bc1511.jpg";